import { render } from "./TzPayWeb.vue?vue&type=template&id=3226a51e&scoped=true"
import script from "./TzPayWeb.vue?vue&type=script&lang=js"
export * from "./TzPayWeb.vue?vue&type=script&lang=js"

import "./TzPayWeb.vue?vue&type=style&index=0&id=3226a51e&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3226a51e"]])

export default __exports__